<template>
    <div class="row">
        <div class="col-12">
            <ibox :title="'Przymierzalnia'">
                <template slot="tools">
                    <router-link :to="`/przymierzalnia/${$route.params.env}/sklepy/dodaj`" class="btn btn-primary btn-xs">
                        Dodaj sklep
                        <i class="fas fa-plus"></i>
                    </router-link>
                </template>
                <template slot="content" slot-scope="{ setLoading }">
                    <data-tables
                        :url="`vnfr/${$route.params.env}/shops/list`"
                        :columns_list="columns_list"
                        @loading="setLoading"
                    />
                </template>
            </ibox>
        </div>
    </div>
</template>

<script>
import Ibox from '@/components/Ibox'
import DataTables from '@/components/DataTables'

export default {
    name: 'ShopsList',
    components: {
        Ibox,
        DataTables
    },
    data() {
        return {
            excel: true,
            columns_list: [
                {
                    key: 'id',
                    name: this.$t( 'edit' ),
                    filter: 'btn',
                    btn: a => `<a href="#/przymierzalnia/${this.$route.params.env}/sklepy/${a}"><i class="fa fa-edit"></i></a>`
                },
                {
                    key: 'lang',
                    name: 'Język',
                    type: 'text',
                    sortable: true
                },
                {
                    key: 'url',
                    name: 'Strona',
                    filter: 'function',
                    col_function: a => `<a href="${a}" target="_blank">${a}</a>`
                }
            ]
        }
    }
}
</script>
